import React, { useState } from "react";

const OnlineBooking = () => {
  const [enabled, setEnabled] = useState(true);
  const [availableFor, setAvailableFor] = useState("All genders");
  const [serviceUpselling, setServiceUpselling] = useState(false);
  const [membershipUpselling, setMembershipUpselling] = useState(true);
  const [selectedMembership, setSelectedMembership] = useState(
    "Cheapest membership"
  );

  return (
    <div className="space-y-10">
      {/* Promo banner */}
      <div className="bg-gradient-to-r from-blue-500 to-cyan-400 rounded-lg p-6 flex items-center justify-between text-white">
        <div>
          <h2 className="text-lg font-semibold mb-2">
            Attract new clients with online bookings
          </h2>
          <p className="text-sm max-w-md">
            Join the world’s largest beauty and wellness marketplace
          </p>
          <button className="mt-4 px-4 py-2 rounded-md bg-white text-blue-600 font-medium hover:bg-gray-100">
            Start now →
          </button>
        </div>
        <img
          src="https://dummyimage.com/220x140/ffffff/000000&text=Preview"
          alt="preview"
          className="rounded-lg shadow-lg"
        />
      </div>

      {/* Online booking toggle */}
      <div className="space-y-4">
        <div className="flex items-center justify-between">
          <div>
            <h3 className="text-lg font-semibold flex items-center gap-2">
              Online booking
              <span
                className={`text-xs px-2 py-0.5 rounded-full ${
                  enabled
                    ? "bg-green-100 text-green-700"
                    : "bg-gray-200 text-gray-600"
                }`}
              >
                {enabled ? "On" : "Off"}
              </span>
            </h3>
            <p className="text-sm text-gray-500">
              Allow clients to book this service online via your marketplace,
              socials, and links
            </p>
          </div>

          {/* Toggle */}
          <button
            onClick={() => setEnabled(!enabled)}
            className={`relative inline-flex h-6 w-11 items-center rounded-full transition-colors ${
              enabled ? "bg-purple-600" : "bg-gray-300"
            }`}
          >
            <span
              className={`inline-block h-4 w-4 transform rounded-full bg-white transition-transform ${
                enabled ? "translate-x-6" : "translate-x-1"
              }`}
            />
          </button>
        </div>

        {/* Available for dropdown */}
        {enabled && (
          <div className="max-w-xs">
            <label className="block text-sm font-medium text-gray-700 mb-1">
              Available for
            </label>
            <select
              value={availableFor}
              onChange={(e) => setAvailableFor(e.target.value)}
              className="w-full border rounded-md px-3 py-2 text-sm"
            >
              <option>All genders</option>
              <option>Female only</option>
              <option>Male only</option>
            </select>
          </div>
        )}
      </div>

      {/* Upselling */}
      <div>
        <h3 className="text-lg font-semibold mb-4">Upselling</h3>
        <p className="text-sm text-gray-500 mb-4">
          Encourage clients to book additional services and memberships when
          booking online.{" "}
          <a href="#" className="text-purple-600 hover:underline">
            Learn more
          </a>
        </p>

        {/* Service upselling */}
        <label className="flex items-start gap-3 mb-4 cursor-pointer">
          <input
            type="checkbox"
            checked={serviceUpselling}
            onChange={() => setServiceUpselling(!serviceUpselling)}
            className="mt-1 h-4 w-4 rounded border-gray-300 text-purple-600 focus:ring-purple-500"
          />
          <div>
            <span className="font-medium">Service upselling</span>
            <p className="text-sm text-gray-500">
              Adds an additional step when booking, where clients can choose
              more services
            </p>
          </div>
        </label>

        {/* Membership upselling */}
        <label className="flex items-start gap-3 cursor-pointer">
          <input
            type="checkbox"
            checked={membershipUpselling}
            onChange={() => setMembershipUpselling(!membershipUpselling)}
            className="mt-1 h-4 w-4 rounded border-gray-300 text-purple-600 focus:ring-purple-500"
          />
          <div className="flex-1">
            <span className="font-medium">Membership upselling</span>
            <p className="text-sm text-gray-500">
              When selecting a service, a specific membership will be suggested
              to the client
            </p>

            {/* Dropdown when enabled */}
            {membershipUpselling && (
              <div className="mt-3 max-w-xs">
                <label className="block text-sm font-medium text-gray-700 mb-1">
                  Selected
                </label>
                <select
                  value={selectedMembership}
                  onChange={(e) => setSelectedMembership(e.target.value)}
                  className="w-full border rounded-md px-3 py-2 text-sm"
                >
                  <option>Cheapest membership</option>
                  <option>Most popular membership</option>
                  <option>Custom membership</option>
                </select>
                <p className="text-xs text-gray-400 mt-1">
                  The system selects the cheapest suitable membership to upsell
                </p>
              </div>
            )}
          </div>
        </label>
      </div>
    </div>
  );
};

export default OnlineBooking;
